import { gql } from "@apollo/client";

export const campusSearch = gql`
  query groupsManagerData($scenarioId: ID!, $filter: CampusFilterInput!) {
    data(scenarioId: $scenarioId) {
      groupsManagerCampuses(filter: $filter) {
        items {
          id
          code
          name
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;
